// DownloadLinks
export { default as DownloadLinks } from "./DownloadLinks";
export type { default as DownloadLinksProps } from "./DownloadLinksProps.interface";

// DownloadLink
export { default as DownloadLink } from "./components/DownloadLink/DownloadLink";
export type { default as DownloadLinkProps } from "./components/DownloadLink/DownloadLinkProps.interface";